import styled, { css } from "styled-components";

// type Props = {
//   bgcolor?;
//   height?;
//   width?;
// };

export const Button = styled.button`
  background-color: ${({ bgcolor, theme }) => bgcolor || theme.colors.primary};
  border: none;
  border-radius: 50%;
  ${({ height = "50px", width = "50px" }) => css`
    width: ${width};
    height: ${height};
  `}

  cursor: pointer;
  &:focus {
    outline: none;
  }
`;
